/**
 * @desc 异常关闭
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.ExportDeclarationAbnormalCloseRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/abnormalClose`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
